import { render, staticRenderFns } from "./StepSon.vue?vue&type=template&id=64ac83f0&scoped=true&"
import script from "./StepSon.vue?vue&type=script&lang=js&"
export * from "./StepSon.vue?vue&type=script&lang=js&"
import style0 from "./StepSon.vue?vue&type=style&index=0&id=64ac83f0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ac83f0",
  null
  
)

export default component.exports